import React, { useContext } from 'react'
import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from 'react-icons/fa'
import styled from 'styled-components'
import AppContext from '../context'
import sounds from '../utils/sounds'
import colors from '../utils/colors'
import WP_DATA from 'utils/wp_data'

const navArrowSize = 42

const NavWrap = styled.div`
  border-radius: 6px;
  background: ${colors.blue};
  padding: 10px;
  margin-bottom: 30px;
  margin-top: 15px;
`

const NavLabel = styled.span`
  text-align: center;
  text-transform: uppercase;
  color: white;
  margin-bottom: 10px;
  display: block;
  & > strong {
    display: block;
    font-size: 22px;
  }
`

const Nav = styled.nav`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
`

const ToolTip = styled.span`
  background: white;
  padding: 10px;
  border-radius: 6px;
  ${props => props.active ? `
    color: ${colors.blue} !important;
    display: block;
    position: static;
  ` : `
    display: none;
    position: absolute;
    top: -86px;
    border: 2px solid ${colors.blue};
    box-shadow: 0px 0px 3px rgba(0,0,0,.5);
    &:after {
      content: " ";
      position: absolute;
      top: 100%; /* At the bottom of the tooltip */
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: white transparent transparent transparent;
    }
  `}
`

const Link = styled.a`
  position: relative;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  padding: 6px 18px;
  border-width: 1px;
  border-color: ${props => props.active ? colors.darkgreen : 'none'};
  background: ${props => props.active ? 'white' : 'transparent'};
  transition: all .25s ease-out;
  &:not(.nav-arrow):after {
    border: 3px solid grey;
    content: '';
    display: ${props => props.active ? 'none' : 'inline-block'};
    height: 16px;
    width: 16px;
    border-color: ${props => props.active ? colors.darkgreen : 'grey'};
    background: ${props => props.active ? colors.green : colors.grey};
    transition: all .25s ease-out;
  }
  &:hover:not(.nav-arrow):after {
    background: white;
  }
  &:hover ${ToolTip} {
    display: inline-block;
  }
  &.nav-arrow {
    svg {
      fill: white;
    }
  }
  &.nav-arrow:hover {
    svg {
      opacity: .7;
    }
  }
`

export default () => {
  const { state, dispatch, save } = useContext(AppContext)
  const keys = [...Object.keys(state.worksheet_data), 'END']
 
  const handleNavClick = e => {
    sounds.click.play()
    dispatch({type: 'SET_VIEW', payload: e.target.id})
  }

  const handleNavArrowClick = dir => {
    const currentIdx = keys.findIndex(k => k === state.view)
    const nextKey = keys[dir + currentIdx]
    if (nextKey) {
      sounds.click.play()
      dispatch({type: 'SET_VIEW', payload: nextKey})
    }
  }

  return (
    <NavWrap>
      <NavLabel>
        <strong>{WP_DATA.worksheet_type.replace(/-/g, ' ')} NAVIGATION</strong>
        Click through each section to update your information.
      </NavLabel>
      <Nav>
        <Link className="nav-arrow" onClick={() => handleNavArrowClick(-1)}>
          <FaArrowAltCircleLeft size={navArrowSize} />
        </Link>
        {keys.map(k => {
          const isActive = state.view === k
          return (
            <Link 
              id={k}
              onClick={isActive ? null : handleNavClick}
              active={isActive}
              key={k}
            >
              <ToolTip active={isActive}>{k}</ToolTip>
            </Link>
          )
        })}
        <Link className="nav-arrow" onClick={() => handleNavArrowClick(1)}>
          <FaArrowAltCircleRight size={navArrowSize} />
        </Link>
      </Nav>
    </NavWrap>
  )
}